import { render, staticRenderFns } from "./reportGeneral.vue?vue&type=template&id=5b9b256a"
import script from "./reportGeneral.vue?vue&type=script&lang=js"
export * from "./reportGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports